import { DateInt12, DateInt8, getDate8AsInt, isset } from "@cawita/core-front";
import { addYears, formatISO, parseISO } from "date-fns";

export function getStartDateFromDate8(date: DateInt8): DateInt12 {
    if (!isset(date) || isNaN(date)) return undefined;
    return date * 10_000;
}
export function getEndDateFromDate8(date: DateInt8): DateInt12 {
    if (!isset(date) || isNaN(date)) return undefined;
    return (date * 10_000) + 2359;
}

export function dateToIso(date: Date) {
    return formatISO(date, { format: 'extended', representation: 'complete' }) ?? undefined;
}

export function dateFromIso(date: string) {
    if (!isset(date)) return undefined;
    return parseISO(date);
}

export function getMinDate(...dates: number[]) { return Math.min(...dates.filter(d => isset(d) && !isNaN(d))); }
export function getMaxDate(...dates: number[]) { return Math.max(...dates.filter(d => isset(d) && !isNaN(d))); }

export function getMinimalDate8(): number { return getDate8AsInt(new Date()); }
export function getMaximalDate8(): number { return getDate8AsInt(addYears(new Date(), 1)); }